import { Component, Input } from "@angular/core";

@Component({
  selector: "app-user-avatar",
  templateUrl: "./user-avatar.component.html",
  styleUrls: ["./user-avatar.component.scss"],
  standalone: false,
})
export class UserAvatarComponent {
  @Input() userDetails: any = {};
  @Input() parentclass: string = "";
  @Input() customWidth: string = "";
  @Input() class: string = "";
  @Input() showUserName: boolean = true;

  // ngOnInit(): void {}
}
